import { render, staticRenderFns } from "./ModerationRoot.vue?vue&type=template&id=235a6365&scoped=true&"
import script from "./ModerationRoot.vue?vue&type=script&lang=js&"
export * from "./ModerationRoot.vue?vue&type=script&lang=js&"
import style0 from "./ModerationRoot.vue?vue&type=style&index=0&id=235a6365&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a6365",
  null
  
)

export default component.exports